// authActions.js
import { createAsyncThunk } from '@reduxjs/toolkit';
import api from './configApi';

export const login = createAsyncThunk('auth/login', async (credentials, { rejectWithValue }) => {
    try {
        //aqui é a chamada da api
        const response = await api.post('/login', credentials);
       // const { token, code } = response.data;
       // console.log(token,'na action')
      //  localStorage.setItem('authToken', token);
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response.data);
    }
});

export const checkAuth = createAsyncThunk('auth/checkAuth', async (_, { rejectWithValue }) => {
    try {
        // Recuperar o token do localStorage
        const token = localStorage.getItem('authToken');
         console.log(token,'tokencheckAuth')
        // Se o token não existir, rejeitar a ação com uma mensagem apropriada
        if (!token) {
            throw new Error('Token não encontrado');
        }
        const response = await api.post('auth/checkAuth'); // O token é adicionado automaticamente pelo interceptor
        // Retornar os dados do usuário se o token for válido
         
        return response.data;
    } catch (error) {
        // Se ocorrer um erro, remover o token e rejeitar a ação
      //  localStorage.removeItem('authToken');
        return rejectWithValue(error.response ? error.response.data : error.message);
    }
});

